import Vue from 'vue';
if (process.browser) {
  var dateRangePicker = require('vue-rangedate-picker');
  Vue.use(dateRangePicker);
}


//////////////////
// WEBPACK FOOTER
// ./plugins/daterange.js
// module id = ./plugins/daterange.js
// module chunks = 82